import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { ApiConstants } from "../enum/Constants";
export class SlotsGameData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.gameId = this.data.getString(ApiConstants.PROPERTY_GAME_ID);
            this.completionReason = this.data.getString(ApiConstants.PROPERTY_COMPLETE_REASON);
            this.completionDate = this.data.getNumber(ApiConstants.PROPERTY_COMPLETION_DATE);
            this.standardSpins = this.data.getNumber(ApiConstants.PROPERTY_STANDARD_SPINS);
            this.standardSpinsUsed = this.data.getNumber(ApiConstants.PROPERTY_STANDARD_SPINS_USED);
            this.standardSpinsRemaining = this.data.getNumber(ApiConstants.PROPERTY_STANDARD_SPINS_REMAINING);
            this.freeSpins = this.data.getNumber(ApiConstants.PROPERTY_FREE_SPINS);
            this.freeSpinsUsed = this.data.getNumber(ApiConstants.PROPERTY_FREE_SPINS_USED);
            this.freeSpinsRemaining = this.data.getNumber(ApiConstants.PROPERTY_FREE_SPINS_REMAINING);
            this.totalStake = this.data.getNumber(ApiConstants.PROPERTY_TOTAL_STAKE);
            this.totalWin = this.data.getNumber(ApiConstants.PROPERTY_TOTAL_WIN);
            this.currencyCode = this.data.getString(ApiConstants.PROPERTY_CURRENCY_CODE);
        }
    }
    getGameId() {
        return this.gameId;
    }
    getCompletionReason() {
        return this.completionReason;
    }
    getCompletionDate() {
        return this.completionDate;
    }
    getStandardSpins() {
        return this.standardSpins;
    }
    getStandardSpinsUsed() {
        return this.standardSpinsUsed;
    }
    getStandardSpinsRemaining() {
        return this.standardSpinsRemaining;
    }
    getFreeSpins() {
        return this.freeSpins;
    }
    getFreeSpinsUsed() {
        return this.freeSpinsUsed;
    }
    getFreeSpinsRemaining() {
        return this.freeSpinsRemaining;
    }
    getTotalStake() {
        return this.totalStake;
    }
    getTotalWin() {
        return this.totalWin;
    }
    getCurrencyCode() {
        return this.currencyCode;
    }
}
//# sourceMappingURL=SlotsGameData.js.map